import {Component, Input, OnInit} from '@angular/core';
import { CommonModule } from '@angular/common';
import {ThemeService} from '../../services/theme-service';
import {ApiService} from '../../services/api.service';
import {AuthorizedApiService} from '../../services/authorized-api.service';
import {TranslateService} from '../../services/translate.service';
import {SnackbarService} from '../../services/snackbar.service';
import {ModalService} from '../../services/modal.service';
import {AppStateService} from '../../services/app-state.service';
import {firstValueFrom} from 'rxjs';
import {ReceiptDetails} from '../../models/ReceiptDetails';
import {LoadingSpinnerComponent} from './loading-spinner-component';
import {DossierViewerComponent} from './dossier-viewer/dossier-viewer.component';
import {PrintInstruction} from '../../models/print-job';

@Component({
  selector: 'app-receipt-display',
  standalone: true,
  imports: [CommonModule, LoadingSpinnerComponent, DossierViewerComponent],
  template: `
    <div>
      <app-loading-spinner *ngIf="!receipt"></app-loading-spinner>
      <app-dossier-viewer *ngIf="receipt" [printInstructions]="instructions" textSize="text-sm"></app-dossier-viewer>
    </div>
  `
})
export class ReceiptDisplayComponent implements OnInit {
  @Input() receiptKey: string | null = null;
  @Input() strip: boolean = false;
  receipt?: ReceiptDetails;
  instructions: PrintInstruction[] | undefined;

  constructor(
    private themeService: ThemeService,
    private authorizedApi: AuthorizedApiService,
    private api: ApiService,
    public translate: TranslateService,
    private snackbar: SnackbarService,
    private modalService: ModalService,
    private appState: AppStateService,
  ) {}

  async ngOnInit(): Promise<void> {
    if (!this.receiptKey) {
      return;
    }
    const appState = await firstValueFrom(this.appState.observeAppState())
    console.log("TAG:REC")
    try {
      this.receipt = await firstValueFrom(this.api.getReceiptDetails(appState.venueId.toString(), this.receiptKey, true));

      if (this.strip) {
        this.instructions = this.stripAwayTopAndBottomLines(this.receipt.dossier.instructions);
      } else {
        this.instructions = this.receipt.dossier.instructions;
      }
    } catch (e) {
      this.snackbar.showMessageForError(e);
    }
  }

  private isDivider(pi: PrintInstruction): boolean {
    return pi.text?.center?.startsWith("----") ?? false;
  }

  private isLastInterestingRow(pi: PrintInstruction): boolean {
    return (pi.text?.left??"") === "Total";
  }

  private stripAwayTopAndBottomLines(instructions: PrintInstruction[]): PrintInstruction[] {
    // Drop all instructions before first divider, then keep all instructions until the last interesting row
    const firstDividerIndex = instructions.findIndex(this.isDivider);
    const lastInterestingRowIndex = instructions.findIndex(this.isLastInterestingRow);
    if (firstDividerIndex === -1 || lastInterestingRowIndex === -1) {
      return instructions;
    }
    const insts = instructions.slice(firstDividerIndex+1, lastInterestingRowIndex + 1);
    return insts;
  }

}
